module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ko","commonjs":"knockout","commonjs2":"knockout","amd":"knockout"}
// module id = 0
// module chunks = 0